import { QarepaEnumInformation } from '@qarepa/common';

export enum CheckRequestStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export const CheckRequestStatusArray: CheckRequestStatusEnum[] = [
  CheckRequestStatusEnum.APPROVED,
  CheckRequestStatusEnum.PENDING,
  CheckRequestStatusEnum.REJECTED,
];

export const CheckRequestStatusInfo: QarepaEnumInformation<CheckRequestStatusEnum> =
  {
    [CheckRequestStatusEnum.PENDING]: {
      name: $localize`Pendiente`,
    },
    [CheckRequestStatusEnum.APPROVED]: {
      name: $localize`Aprobado`,
    },
    [CheckRequestStatusEnum.REJECTED]: {
      name: $localize`Rechazado`,
    },
  };
